import { useDispatch } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import {
  fetchDataSourcesStateThunk,
  fetchDataSourceStateByIdThunk,
  fetchDataSourcesThunk,
} from "./thunks";
import { fetchMappedDataSources } from "../../requests/dataSources/requestCreators";
import flowioast from "../../utils/flowioast";

export const useFetchDataSources = () => {
  const dispatch = useDispatch();

  return useCallback(() => dispatch(fetchDataSourcesThunk()), [dispatch]);
};

export const useFetchDataSourcesState = () => {
  const dispatch = useDispatch();
  return useCallback(
    (idsOfDataSources?: number[]) =>
      dispatch(fetchDataSourcesStateThunk(idsOfDataSources)),
    [dispatch]
  );
};

export const useFetchDataSourceState = () => {
  const dispatch = useDispatch();

  return useCallback(
    (dataSourceId: number) =>
      dispatch(fetchDataSourceStateByIdThunk(dataSourceId)),
    [dispatch]
  );
};

export const useMappedDataSources = (
  idsOfDataSources: number[],
  updateSourcesLength: (newLength: number) => void
) => {
  const [idsOfMappedDataSources, setMappedSources] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (idsOfDataSources.length) {
      setIsLoading(true);
      fetchMappedDataSources(idsOfDataSources)
        .then(({ data }) => {
          // vyfiltruju pouze namapovane datove zdroje a vratim pole jejich idcek;
          const onlyMappedDataSources = Object.keys(data)
            .map((key) => Number(key))
            .filter((value) => data[value]);
          setMappedSources(onlyMappedDataSources);
          updateSourcesLength(onlyMappedDataSources.length);
        })
        .catch((e) => {
          flowioast.error.fromIntlBase("datasource.fetch.plural", e);
        })
        .finally(() => setIsLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idsOfDataSources.length]);

  return {
    mappedDataSources: idsOfMappedDataSources,
    isLoading,
  };
};
